import script from "./AppSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./AppSwitcher.vue?vue&type=style&index=0&id=e9937488&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9937488"]])

export default __exports__